export interface AppUser {
  id: string;
  email: string;
  displayName: string | null;
  isActive: boolean;
  isOwner: boolean;
  isViewer: boolean;
  createdAt: string;
}

export interface UpdateUserRequest {
  isActive?: boolean;
  isOwner?: boolean;
  isViewer?: boolean;
}

/** Must be an @haystackrobotics.com address - invited users have no password and sign in via Microsoft SSO. */
export const ALLOWED_INVITE_EMAIL_DOMAIN = "haystackrobotics.com";

export interface InviteUserRequest {
  email: string;
  displayName?: string;
}
